exports.IDS = {
  // IMG_URL: "http://127.0.0.1:4343",
  IMG_URL: "https://excellencenode.profcymadev.com:1516",
  // IMG_URL: "http://127.0.0.1:1412",
  PAGE: 1,
  PERPAGE: 10,
  TOTALPAGES: 1,
  TOTAL: 1,
  ACTIVE: "Active",
  INACTIVE: "Inactive",
  SLICESTATUS: {
    Idle: "idle",
    Loading: "loading",
    Succeeded: "succeeded",
    Failed: "failed",
  },
};
